import { C02AccordionViewMoreProps } from './C02AccordionViewMore.types';
import { useI18n } from 'next-localization';
import { TextAccordionProps } from '@ahc-digital/component-library';
import { useConditionalRendering } from 'src/shared/useConditionalRendering';
import { getCheckbox, getDroplink } from 'src/shared/param-utils';

export function CreateC02AccordionViewMoreModel(
  props?: C02AccordionViewMoreProps
): TextAccordionProps {
  const { params, fields } = props || {};
  const { t } = useI18n() || {};
  const { renderImage, renderRichText, renderText } = useConditionalRendering();
  const showMoreText = t('Text Accordion-Show More');
  const showLessText = t('Text Accordion-Show Less');

  return {
    alwaysVisibleText: renderRichText(props?.fields?.AlwaysVisibleText, {
      required: true,
    }),
    ctaAlignment: getDroplink(params?.CtaAlignment, 'center'),
    ctaStyle: getDroplink(params?.CtaStyle, 'link'),
    supportCopyAlignment: getDroplink(params?.SupportCopyAlignment, 'left'),
    headlineAlignment: getDroplink(params?.HeadlineAlignment, 'left'),
    headlineTag: getDroplink(params?.HeadlineTag, 'p'),
    image: renderImage(fields?.Image),
    imagePosition: getDroplink(params?.ImagePosition, 'left'),
    headline: renderText(fields?.Headline),
    hiddenText: renderRichText(fields?.HiddenText, { required: true }),
    showLessText,
    showMoreText,
    shouldDisplayGoldBar: getCheckbox(params?.ShouldDisplayGoldBar),
    goldBarAlignment: getDroplink(params?.GoldBarAlignment, 'left'),
  };
}
